import { StatsData, TableColumn } from '@shared/interfaces';
import { Advertisers } from '../interfaces';

/**
 * The columns for the advertisers table.
 */
export const ADVERTISERS_COLUMNS: TableColumn[] = [
    { field: 'name', header: 'Name', width: '250px', hasRedirect: true },
    { field: 'region', header: 'Region', width: '150px' },
    { field: 'state', header: 'State', width: '100px' },
    { field: 'status', header: 'Status', width: '150px' },
    { field: 'dealer', header: 'Dealer', width: '150px' },
    { field: 'dateCreated', header: 'Date Created', width: '200px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '120px',
        type: 'actions',
        actions: [{ icon: 'delete', name: 'delete', color: '#FF0000' }],
    },
];

/**
 * Dummy advertiser data matching the table columns.
 */
export const ADVERTISERS_DATA: Advertisers[] = [
    {
        id: '1',
        name: 'Automation Update admin',
        region: 'SE',
        state: 'FL',
        status: 'Inactive',
        dealer: '099-STME',
        dateCreated: '10/01/24 12:03 AM',
    },
    {
        id: '2',
        name: 'John Doe Advertiser',
        region: 'NE',
        state: 'NY',
        status: 'Active',
        dealer: '123-ABCD',
        dateCreated: '01/15/25 09:30 AM',
    },
    {
        id: '3',
        name: 'Miami Beach Ads',
        region: 'SE',
        state: 'FL',
        status: 'Active',
        dealer: '055-MIAM',
        dateCreated: '02/10/25 02:45 PM',
    },
];

/**
 * Dummy stats data for advertisers.
 */
export const ADVERTISERS_STATS: StatsData[] = [
    {
        title: 'Host(s)',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'dealers',
        total: '200',
        stats: [
            { label: 'Active', value: '100', colorClass: 'text-orange-400' },
            { label: 'Inactive', value: '100', colorClass: 'text-blue-500' },
        ],
    },
    {
        title: 'New this week',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'dealers',
        total: '100',
        stats: [{ label: 'Last Week', value: '8.3%', colorClass: 'text-orange-400' }],
    },
    {
        title: 'New last week',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'dealers',
        total: '20',
        stats: [{ label: 'Last Week', value: '8.3%', colorClass: 'text-orange-400' }],
    },
];
